var _g;
import { jsx as _jsx } from "react/jsx-runtime";
var Visa = function Visa(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size * 3.25,
    height: size,
    viewBox: "0 0 26 8",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    children: /*#__PURE__*/_jsx("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fillRule: "evenodd",
      children: /*#__PURE__*/_jsx("g", {
        id: "PC-1366-Copy-11",
        transform: "translate(-1044.000000, -1429.000000)",
        fill: !ignoreColor ? color : undefined,
        children: _g || (_g = /*#__PURE__*/_jsx("g", {
          id: "Group-4",
          transform: "translate(0.000000, 922.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Group-2",
            transform: "translate(1044.000000, 504.000000)",
            children: /*#__PURE__*/_jsx("g", {
              id: "Page-1",
              children: /*#__PURE__*/_jsx("g", {
                id: "Group-15",
                transform: "translate(0.000000, 0.011200)",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M22.128,7.773 L23.336,5.245 C23.474,4.961 23.587,4.668 23.676,4.362 C23.661,4.561 23.653,4.793 23.653,5.058 L23.665,5.517 L23.759,7.773 L22.128,7.773 Z M25.318,3.112 L22.518,3.112 L18.375,10.891 L20.636,10.891 L21.332,9.433 L23.826,9.433 L23.882,10.891 L26.003,10.891 L25.318,3.112 Z M16.95,6.357 C16.601,6.105 16.364,5.904 16.24,5.753 C16.115,5.602 16.053,5.44 16.053,5.267 C16.053,5.075 16.117,4.929 16.245,4.83 C16.374,4.731 16.556,4.681 16.794,4.681 C17.239,4.681 17.779,4.837 18.414,5.149 L19.166,3.569 C18.457,3.19 17.659,3 16.772,3 C16.222,3 15.726,3.102 15.282,3.306 C14.838,3.509 14.495,3.797 14.252,4.168 C14.009,4.539 13.887,4.957 13.887,5.421 C13.887,5.836 13.985,6.217 14.182,6.565 C14.379,6.912 14.694,7.253 15.129,7.586 C15.485,7.871 15.704,8.053 15.786,8.137 C15.868,8.22 15.931,8.304 15.975,8.387 C16.02,8.47 16.042,8.56 16.042,8.656 C16.042,8.858 15.971,9.014 15.831,9.125 C15.69,9.235 15.482,9.29 15.207,9.29 C14.88,9.29 14.515,9.225 14.113,9.097 C13.71,8.97 13.353,8.812 13.041,8.624 L13.041,10.486 C13.304,10.653 13.618,10.78 13.982,10.867 C14.346,10.954 14.732,10.997 15.14,10.997 C16.116,10.997 16.877,10.778 17.423,10.34 C17.969,9.902 18.241,9.29 18.241,8.502 C18.241,8.062 18.136,7.671 17.924,7.332 C17.712,6.991 17.388,6.666 16.95,6.357 Z M10.918,3.112 L9.197,10.891 L11.408,10.891 L13.128,3.112 L10.918,3.112 Z M7.832,3.112 L5.883,7.395 C5.79,7.58 5.701,8.31 5.701,8.31 L5.43,8.31 L5.371,7.374 C5.371,7.374 4.929,5.424 4.644,4.162 C4.39,3.101 4.215,3.112 3.608,3.112 C2.365,3.112 0,3.121 0,3.121 L0,3.38 C1.078,3.38 2.217,4.073 2.56,5.332 C3.132,7.63 3.944,10.891 3.944,10.891 L6.372,10.891 L10.137,3.1119977 L7.832,3.112 Z",
                  id: "Fill-13"
                })
              })
            })
          })
        }))
      })
    })
  });
};
export default Visa;